import { Routes } from '@angular/router';
import { NotFound404Component } from './not-found-404/not-found-404.component';
import { OptionSniperT3Component } from './scans/option-sniper-t3/option-sniper-t3.component';
import { AuthGuard } from './@shared/auth-guard';

export const routes: Routes = [
  {
    path: 'alpha-shark',
    children: [
      {
        path: 'option-sniper',
        component: OptionSniperT3Component,
        title: 'Option Sniper',
        canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: '**',
    pathMatch: 'full',
    component: NotFound404Component
  }
];